var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClassContainer(),on:{"click":_vm.callAction}},[(_vm.iconName)?_c('span',{staticClass:"material-icons",class:_vm.getClassIcon()},[_vm._v(_vm._s(_vm.iconName))]):_vm._e(),_c('div',{class:_vm.getClasstext()},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }